import type { Customer } from '../types/customers.types';

// CSV field configuration - maps column names to value extractors
const CSV_FIELDS: Record<string, (customer: Customer) => string> = {
    'Full Name': (customer: Customer) => `"${customer.fullName || ''}"`,
    Email: (customer: Customer) => customer.email || '',
    'Phone Number': (customer: Customer) => `"${customer.phoneNumber || ''}"`,
    'Total Purchases': (customer: Customer) => String(customer.totalPurchases || 0),
    'Fan Since Date': (customer: Customer) => `"${customer.fanSinceDate || ''}"`,
    'Total Amount Spent': (customer: Customer) => String(customer.totalSpent || 0),
    'Active Subscriptions Count': (customer: Customer) => String(customer.active || 0),
    'Cancelled Subscriptions Count': (customer: Customer) => String(customer.cancelled || 0),
    'Last Cancellation Date': (customer: Customer) => `"${customer.lastCancelledAt || ''}"`,
    'Email Subscription Status': (customer: Customer) => customer.email_subscription_status || '',
};

/**
 * Generates CSV content from customer data
 */
export function generateCSV(data: Customer[]): string {
    const headers = Object.keys(CSV_FIELDS);
    const headerRow = headers.join(',');

    const rows = data.map(customer => {
        return headers
            .map(header => {
                const getter = CSV_FIELDS[header];
                return getter?.(customer) ?? '';
            })
            .join(',');
    });

    return [headerRow, ...rows].join('\n');
}

/**
 * Downloads a CSV file with the given content
 */
export function downloadCSV(csvContent: string, filename: string): void {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
}

/**
 * Generates a filename for the exported CSV
 */
export function generateExportFilename(): string {
    const today = new Date();
    return `Your Stan Audience - ${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}.csv`;
}
